import React from 'react'

function LabelCustomSmall(props) {
  const { children, className, ...other } = props

  return (
    <label {...other} className={`fw-light font-small-2 ${className}`}>
      {children}
    </label>
  )
}

export default LabelCustomSmall
